export const useTicketStyles = () => {
  return {
    ticketForm: {
      flexWrap: 'wrap',
      gap: '10px',
      width: '600px',
    },
  };
};
